



















































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { randomId } from "@/utils";
import { PatientFilter } from "@/store/modules/types";
import { BPopover, BFormDatepicker } from "bootstrap-vue";
import { VueEditor } from "vue2-editor";
import SelectPopover from "@/components/SelectPopover.vue";

@Component({
  components: {
    BPopover,
    BFormDatepicker,
    VueEditor,
    SelectPopover,
  },
  computed: {
    ...mapState("cases", ["carePlan"]),
  },
})
export default class TaskPopover extends Vue {
  id = "case-task-popover";
  target = "case-task-popover-target";
  task = {
    carePlanTaskId: null,
    key: randomId(6),
    description: "",
    statusId: "OPN",
    priorityId: "NM",
    dueDate: new Date(),
    isDefault: false,
  };
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  calendarFormat = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
  };
  save() {
    this.$emit("saved", this.task);
    this.close();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {}
}
